<template>

    <div>
        <div class="modal fade" id="HrTeamsTrashcanModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Prullenbak</h4>
                    </div>
                    <div class="modal-body">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Naam</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="trashedTeams.length === 0">
                                    <td colspan="2">Er zijn geen teams gevonden</td>
                                </tr>
                                <tr v-for="team in trashedTeams" :id="'trashed-team-' + team.id">
                                    <td>
                                        {{ team.name }}
                                    </td>
                                    <td class="text-right">
                                        <div class="btn-group btn-group-xs">
                                            <button
                                                class="btn btn-default btn-xs"
                                                @click="restoreTeam(team.id)"
                                                v-tooltip="'Team herstellen'"
                                            >
                                                <i class="mdi mdi-backup-restore"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';

    export default {

        methods: {
            openModal() {
                this.$forceUpdate();
                $('#HrTeamsTrashcanModal').modal('show');
            },

            restoreTeam(team_id) {
                axios.post(this.route('api.v1.hr.teams.restore', {id: team_id}))
                    .then(resp => {
                        if (resp.data.success) {
                            window.jQuery("#trashed-team-" + team_id).remove();
                            this.$snotify.success('Het team is hersteld.');
                        } else {
                            this.$snotify.error('Er is een fout opgetreden bij het herstellen van het team.');
                        }
                    });
            }
        },

        mounted() {
            window.jQuery('#HrTeamsTrashcanModal').on('hidden.bs.modal', event => this.$emit("hidden"));
        },

        name: "HrTeamsTrashcanModal",

        props: {
            trashedTeams: {
                required:true,
                type:Array,
            },
        },

    }

</script>
